import * as Yup from "yup";
import { DELIVERY_TYPES } from "constants";

export const doSchema = Yup.object().shape({
  pickUpSlotFrom: Yup.string().when("deliveryType", {
    is: DELIVERY_TYPES?.jots,
    then: Yup.string().required("Please enter Pick-up slot: From field"),
    otherwise: Yup.string().notRequired(),
  }),
  pickUpSlotTo: Yup.date().when("deliveryType", {
    is: DELIVERY_TYPES?.jots,
    then: Yup.date().required("Please enter Pick-up slot: To field"),
    otherwise: Yup.date().notRequired(),
  }),
  sellerAddress: Yup.string().when("deliveryType", {
    is: DELIVERY_TYPES?.jots || DELIVERY_TYPES.sellerDelivery,
    then: Yup.string().required("Seller address is required"),
    otherwise: Yup.string().notRequired(),
  }),
});
